import type { WithActiveBranchId } from '@app/api/shared';

export enum CertificatesEndpoints {
  GetCertificates = 'GetCertificates',
  GetCertificateById = 'GetCertificateById',
  CreateCertificate = 'CreateCertificate',
  EditCertificate = 'EditCertificate',
  DeleteCertificate = 'DeleteCertificate',
  GetCertificatesForSale = 'GetCertificatesForSale',
}

/** Сертификат */
export interface ModelCertificate {
  Id: number;
  BranchId: number;
  Name: string | null;
  /** Стоимость */
  Cost: number;
  IsDeleted: boolean;
}

/** Сертификат на записи */
export interface ModelRecordCertificate {
  /** ID проданного сертификата (не 0, если сертификат продан клиенту) */
  Id: number;
  /** ID сертификата из справочника */
  CertificateId: number;
  Name: string | null;
  /** Если допродажа — ID пользователя, который продал */
  SellerId: number | null;
  /** Стоимость */
  Cost: number;
  /** Скидка (задаётся в окне записи) */
  Discount: number;
  /** Количество — всегда 1 */
  Count: number;
  /** Сертификат можно изменить и удалить с записи */
  CanEditAndDelete: boolean;
}

export type GetCertificatesRequest = WithActiveBranchId<{
  /** Поиск по названию */
  searchTerm?: string;
}>;

export type GetCertificateByIdRequest = WithActiveBranchId<{
  certificateId: number;
}>;

export type CreateCertificateRequest = WithActiveBranchId<{
  data: ModelCertificate;
}>;

export type EditCertificateRequest = WithActiveBranchId<{
  data: ModelCertificate;
}>;

export type DeleteCertificateRequest = WithActiveBranchId<{
  certificateId: number;
}>;

export type GetCertificatesForSaleRequest = WithActiveBranchId;

export type GetCertificatesResponse = ModelCertificate[];
export type GetCertificatesForSaleResponse = ModelRecordCertificate[];
export type GetCertificateByIdResponse = ModelCertificate;
export type CreateCertificateResponse = ModelCertificate;
export type EditCertificateResponse = ModelCertificate;
export type DeleteCertificateResponse = void;
